export default __webpack_public_path__ + "static/media/add-icon.d08c8b95.svg";